export const caracteristicaType = (opcoes, selecao, tipo_de_valor) => {
	let type = tipo_de_valor === 'numero' ? 'numero' : 'texto';
	if (selecao === 1) type = 'selecao';
	if (selecao === 2) type = 'multipla_escolha';
	return type;
};
